/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsTray = {
  init: function ($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsTray = $.extend(this, window.PXUTheme.getSectionData($section));

    this.delegateElement = new domDelegate.Delegate($section[0]);
    this.domDelegate = new domDelegate.Delegate(document.body);
    
    this.element = $section.get(0).querySelector(".Section__tray");    
    var $this = this;

    if (this.template == "index") {
      if (!window.PXUTheme.media_queries.smallDesktop.matches) {
        setTimeout(function(){
          $this.open();
        }, 1000);
      } else {
        let interval = setInterval(function(){
          let anotherBanner = document.querySelector(".shopify-pc__banner__dialog");
          if (anotherBanner) {
            $(anotherBanner).animate({
              bottom: 0
            }, 400);
            clearInterval(interval);
          }
        }, 10)
      }
      this.attachEvenListeners();
    }

  },
  attachEvenListeners: function(){
    this.delegateElement.on('click', '[data-action="close"]', this.close.bind(this));
    var $this = this;
    window.addEventListener("scroll", () => {
      $this.handleMobileButton();
    });
    window.addEventListener("resize", () => {
      $this.documentFullHeight = document.body.scrollHeight;
    })
  },
  open: function() {
    console.log("asd")
    let _this = this;
    document.dispatchEvent(new CustomEvent('tray:action', { 
      detail: {
        appear: true,
        element: _this.element
      } 
    }));
    this.element.classList.add("Reveal");
    this.handleCookieBanner("open");
  },
  close: function(event) {
    this.element.classList.remove("Reveal");
    this.handleCookieBanner("close");
    let _this = this;
    document.dispatchEvent(new CustomEvent('tray:action', { 
      detail: {
        appear: false,
        element: _this.element
      } 
    }));
  },
  handleMobileButton: function() {
    if (!window.PXUTheme.media_queries.smallDesktop.matches) return; 
    this.documentFullHeight = document.body.scrollHeight;
    var scrollOffset = window.scrollY;
    
    let _this = this;
    if (scrollOffset < 0.1 * this.documentFullHeight) {
      if (this.element.classList.contains("Reveal")) {
        this.element.classList.remove("Reveal");
        document.dispatchEvent(new CustomEvent('tray:action', { 
          detail: {
            appear: false,
            element: _this.element
          } 
        }));
        this.handleCookieBanner("close");
      }
    } else {
      if (!this.element.classList.contains("Reveal")) {
        document.dispatchEvent(new CustomEvent('tray:action', { 
          detail: {
            appear: true,
            element: _this.element
          } 
        }));
        this.element.classList.add("Reveal");
        this.handleCookieBanner("open");
      }
    }
  },
  unload: function ($section) {
  },
  handleCookieBanner(action) {
    let cookieBanner = document.querySelector(".shopify-pc__banner__dialog");
    if (action === "open") {
      $(cookieBanner).animate({
        bottom: window.PXUTheme.media_queries.smallDesktop.matches ? this.element.clientHeight + 24 : this.element.clientHeight
      }, 200);
    } else {
      $(cookieBanner).animate({
        bottom: 0
      }, 400);
    }
  }
}

/******/ })()
;